"use client";

import { useState } from "react";
import MobileNav from "./MobileNav";
import Logo from "@/components/Logo";
import Link from "next/link";

import HeaderProductSearch from "./HeaderProductSearch";

export default function MobileHeaderClient() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex flex-col z-[90] px-4 py-5 font-dana sm:p-6 sm:pb-6">
      {/* Top Row: Logo & Menu Toggle */}
      <div className="mb-6 flex w-full items-center justify-between sm:mb-8">
        <Link href="/" className="shrink-0">
          <Logo className="h-9 w-auto" />
        </Link>

        <button
          onClick={() => setIsOpen(true)}
          className="flex flex-col gap-[5px] p-2"
          aria-label="Open Menu"
        >
          <div className="w-5 h-[2px] rounded-4xl bg-berry-500 rounded-full" />
          <div className="w-5 h-[2px] rounded-4xl bg-white/80 rounded-full" />
          <div className="w-3 h-[2px] rounded-4xl bg-white/80 rounded-full self-end" />
        </button>
      </div>

      {/* Search Bar */}
      <div className="relative px-1">
        <HeaderProductSearch />
      </div>

      <MobileNav isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  );
}
